<template>
  <el-card style="margin-bottom:20px;">
    <div slot="header" class="clearfix">
      <span>About me</span>
      <el-button style="float: right; padding: 3px 0" type="text">Edit</el-button>
    </div>
    <div class="user-profile">
      <div class="box-center">
        <pan-thumb :image="user.avatar" :height="'100px'" :width="'100px'" :hoverable="false">
          <div>Hello</div>
          {{ user.role }}
        </pan-thumb>
      </div>
      <div class="box-center">
        <div class="user-name text-center">{{ user.role }} {{ user.name }}</div>
      </div>
    </div>
    <div class="user-bio">
      <div class="user-bio-section">
        <div class="user-bio-section-header">
          <i class="el-icon-message"></i><span>Email</span>
        </div>
        <div class="user-bio-section-body">
          <div class="text-muted">
            {{ user.email }}
          </div>
        </div>
      </div>
      <div class="user-bio-section">
        <div class="user-bio-section-header">
          <i class="el-icon-phone-outline"></i><span>Tel</span>
        </div>
        <div class="user-bio-section-body">
          <div class="text-muted">
            {{ user.phone }}
          </div>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import PanThumb from '@/atoms/PanThumb'
export default {
  components: { PanThumb },
  props: {
    user: {
      type: Object,
      default: () => {
        return {
          name: '',
          email: '',
          avatar: '',
          role: ''
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
 .box-center {
   margin: 0 auto;
   display: table;
 }
 .text-muted {
   color: #777;
 }
 .user-profile {
   .user-name {
     font-weight: bold;
   }
   .box-center {
     padding-top: 10px;
   }
   .box-social {
     padding-top: 30px;
     .el-table {
       border-top: 1px solid #dfe6ec;
     }
   }
   .user-follow {
     padding-top: 20px;
   }
 }
 .user-bio {
   margin-top: 20px;
   color: #606266;
   span {
     padding-left: 4px;
   }
   .user-bio-section {
     font-size: 14px;
     padding: 15px 0;
     .user-bio-section-header {
       border-bottom: 1px solid #dfe6ec;
       padding-bottom: 10px;
       margin-bottom: 10px;
       font-weight: bold;
     }
   }
 }
</style>